module.exports = __webpack_public_path__ + "static/media/570JamesPBrawleyDrNW_2018-06-12_178.22cc2bf4.jpg";